import COLORS from "../../../UI/Theme/colors";

const style: any = (): any => ({
  btnSubmit: {
    marginTop: "1rem",
  },
  fileName: {
    fontSize: "0.875rem",
    color: COLORS.DARK_GRAY,
    marginLeft: "1rem",
  },
  label: {
    minHeight: 21,
    color: "rgb(36, 44, 52)",
    fontSize: "0.875rem",
    "word-break": "break-all",
    "font-weight": "bold",
    display: "flex",
    alignItems: "center",
    paddingBottom: "0.5rem",
  },
  uploadFileTemplate: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    paddingTop: 10
  },
  templateLink: {
    color: "#005fbe",
    fontSize: "0.75rem",
    display: "block",
    textDecoration: "none",
    fontWeight: 500,
    width: "fit-content",
  },
});

export default style;
